import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SecondaryButton } from 'components/Shared/Button'
import PortalModal from 'components/Shared/PortalModal'
import EvaluationModalComponent from './elements/EvaluationModal.component'

const EvaluationComponent = ({ packageId, onEvaluationUpdated, backhaulAttribution }) => {
  const [isOpen, setIsOpen] = useState(false)

  const { t } = useTranslation()

  // return
  return (
    <>
      <SecondaryButton 
        text={t('PackageBuilder.packageBuilderResults.evaluationButton')}
        onClick={() => setIsOpen(true)}
        color="navy"
        fullWidth={false}
      />

      <PortalModal 
        isOpen={isOpen}
        onClickOutside={() => setIsOpen(false)}
        title={t('PackageBuilder.packageBuilderResults.evaluationModal.title')}
        className="evaluation-modal-wrapper"
      >
        <EvaluationModalComponent
          packageId={packageId}
          backhaulAttribution={backhaulAttribution}
          onEvaluationUpdated={onEvaluationUpdated}
          onClose={() => setIsOpen(false)}
        />
      </PortalModal>
    </>
  )
}

export default EvaluationComponent